const errorColumnMap = {
  degree_name: 'Degree Name',
  school_name: 'Institute Name',
  passing_year: 'Passing Year',
  grade: 'Cgpa',
  company_name: 'Company Name',
  designation: 'Designation',
  start_date: 'Start Date',
  end_date: 'End Date',
  number_of_projects: 'No. of Projects',
  experience_year: 'Years of Experiences',
  description: 'description',
  duration: 'Time Estimated',
  spend_time: 'Time Spent',
  date_of_birth: 'Date of Birth',
  address: 'Address',
};

export default errorColumnMap;
